import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchPosts, type PostsParams } from '../../../../entities/post/api/index';

// Public custom hook
export function useInfinitePosts(params: PostsParams & { enabled?: boolean }) {
  return useInfiniteQuery({
    queryKey: [
      'posts',
      params.queryId,
      params.startDate,
      params.endDate,
      params.limit,
      params.sortBy,
      params.publicFilter,
      params.privateFilter,
    ],
    queryFn: ({ pageParam, signal }) =>
      fetchPosts(
        {
          ...params,
          searchAfter: pageParam,
        },
        signal,
      ),
    getNextPageParam: (lastPage) => lastPage.next_token || undefined,
    initialPageParam: undefined as string | undefined,
    enabled: params.enabled,
  });
}
